<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
        <thead class="thead-light">
            <tr>
                <th scope="col"><app-toolkit-table-sort title="ID" (sortTableOutput)="sortTable($event, 0)" [tableSortField]="tableSort[0]" [disabled]="!items.content.length"></app-toolkit-table-sort></th>
                <th scope="col"><app-toolkit-table-sort title="Provincia" (sortTableOutput)="sortTable($event, 1)" [tableSortField]="tableSort[1]" [disabled]="!items.content.length"></app-toolkit-table-sort></th>
                <th scope="col"><app-toolkit-table-sort title="Comune" (sortTableOutput)="sortTable($event, 2)" [tableSortField]="tableSort[2]" [disabled]="!items.content.length"></app-toolkit-table-sort></th>
                <th scope="col">Macro tipologia opera</th>
                <th scope="col">Tipologia opera</th>
                <th scope="col">Provenienza</th>
                <th scope="col">Materiale costruzione</th>
                <th scope="col">Corso d'acqua</th>
                <th style="min-width: 85px;" scope="col">CUP</th>
                <th scope="col">Stato</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items.content">
                <td>{{ item.idOpera }}</td>
                <td>{{ item.denProv}}</td>
                <td>{{ item.denComune }}</td>
                <td>{{ item.macroTipologiaOpera | anagraficaMacroTipologiaOpera: (datalist.macroTipologiaOpera || []) }}</td>
                <td>{{ item.idTipologiaOpera | anagraficaTipologiaOpera: (datalist.tipologiaOpera || []) }}</td>
                <td>{{ item.provenienza }}</td>
                <td>{{ item.idMaterialeCostruzione | anagraficaMateriale: (datalist.materiale || []) }}</td>
                <td>{{ item.trattoIdrico }}</td>
                <td>{{ item.cups[0]?.toString() }}<app-toolkit-bl-icon *ngIf="item.cups.length > 1" triggers="click:blur" container="body" [ngbTooltip]="item.cups.slice(1).toString()" icon="plus" cssClass="icon icon-sm icon-primary pl-2"></app-toolkit-bl-icon></td>
                <td>{{ item.idStato | anagraficaStatoOpera: (datalist.statoOpera || [])}}</td>
                <td class="actions">
                    <button aria-label="accedi al dettaglio" type="button" class="btn btn-xs btn-link"
                        (click)="goToOpera(item.idOpera)"
                        container="body" ngbTooltip="Accedi al dettaglio">
                        <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button>
                    <!-- <button type="button" class="btn btn-xs btn-link ml-1"
                        (click)="goToViewer(item.idOpera, item.codIstat, item.idTipologiaOpera)"
                        container="body" ngbTooltip="Accedi al viewer">
                        <app-toolkit-bl-icon icon="map-marker" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    </button> -->
                </td>
            </tr>
            <tr *ngIf="!items.content.length">
                <td colspan="13"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<ngb-pagination
    *ngIf="items.content.length"
    [(page)]="paginator.page"
    [pageSize]="paginator.size"
    [collectionSize]="paginator.total"
    (pageChange)="onPageChange($event)"
    [maxSize]="5"
></ngb-pagination>